import HR2021Theme from '@amzn/stencil-react-theme-default';
export const adjustedTheme = {
  ...HR2021Theme,
  color: {
    ...HR2021Theme.color,
    primary: '#23756b',
    secondary: '#195f57',
    primary05: '#ebf9f6',
    primary60: '#008574',
    primary70: '#23756b',
    primary80: '#195f57',
    primaryLabelText: '#5c7273',
    greybBg: '#F0F1F2',
    whiteBg: '#FFFFFF',
  },
};
